import { isEmpty, get } from 'lodash';
import { useMemo, useRef } from 'react';

import { CardTable, Cell } from '@summer/ui-components';

import { Box, Flex } from 'components/box/Box';
import DateCell from 'components/cells/DateCell';
import Loading from 'components/placeholders/Loading';
import NoDataToDisplay from 'components/placeholders/NoDataToDisplay';
import { useSummerHistory } from 'hooks/useSummerHistory';
import { useBorrowers } from 'state/server/borrowers';

const BorrowersTable = ({ filters }: any) => {
  const history = useSummerHistory();
  const containerRef = useRef<any>();
  const { borrowers, isLoading } = useBorrowers({ filters });

  const borrowersToDisplay = useMemo(() => {
    return filters &&
      Object?.keys(filters)?.some(
        key => filters[key] !== null || filters[key] !== undefined,
      )
      ? borrowers
      : [];
  }, [borrowers, filters]);

  const columns = useMemo(() => {
    return [
      { Header: 'Borrower ID', accessor: 'id' },
      { Header: 'First Name', accessor: 'firstName' },
      { Header: 'Last Name', accessor: 'lastName' },
      { Header: 'Email', accessor: 'email' },
      {
        Header: 'Account Created',
        accessor: 'createdAt',
        Cell: ({ cell }: any) => (
          <DateCell value={cell.value} formatString="MMM d yyyy" />
        ),
      },
      {
        Header: 'Partner',
        accessor: 'partnerName',
        Cell: ({ cell }: any) => <Cell type="string" value={cell.value} />,
      },
    ];
  }, []);

  return (
    <Box as="section" mt={32} mb={32} flex="1" ref={containerRef}>
      {isLoading && (
        <Flex justifyContent="center" alignItems="center">
          <Loading />
        </Flex>
      )}
      {!isLoading &&
        (isEmpty(borrowersToDisplay) ? (
          <NoDataToDisplay />
        ) : (
          <CardTable
            columns={columns}
            data={borrowersToDisplay}
            align="left"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment -- pre-existing; surfaced by reflow from a type-only change
            style={{ overflow: 'hidden' } as any}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing; surfaced by reflow from a type-only change
            getCustomRowProps={(props: any, options: any) => {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- pre-existing; surfaced by reflow from a type-only change
              const { row } = options;
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- pre-existing; surfaced by reflow from a type-only change
              const borrowerId = get(row, 'original.id');

              // combine row props With our custom row props
              const style = { ...props.style };
              return {
                ...props,
                style,
                onClick: () => {
                  history.push(`/borrowers/${borrowerId}`);
                },
              };
            }}
            virtualizedOptions={{
              height: 690 - 62,
            }}
          />
        ))}
    </Box>
  );
};

export default BorrowersTable;
